import React from 'react';

/** Magica Atelier icon set — warm workshop glyphs (no neon). */
const base = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export function IconWand(props) {
  return (
    <svg {...base} {...props}>
      <path d="M15 4v2M17.5 6.5 19 5M20 9h-2M4 20l9.5-9.5" />
      <path d="m13.5 10.5 2 2" />
      <circle cx="9" cy="7" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconTools(props) {
  return (
    <svg {...base} {...props}>
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.5-2.5 2.5-2.5Z" />
      <path d="m18 2 4 4" />
    </svg>
  );
}

export function IconKey(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="8" cy="10" r="3.5" />
      <path d="M11 10h10v2h-2v3h-2v-3h-2" />
    </svg>
  );
}

export function IconMuseum(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3 10.5 12 4l9 6.5" />
      <path d="M5 10.5V19h14v-8.5" />
      <path d="M9 19v-5h6v5" />
    </svg>
  );
}

export function IconSquad(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="9" cy="8" r="2.5" />
      <circle cx="16" cy="9" r="2" />
      <path d="M4.5 18c.6-2.4 2.5-3.5 4.5-3.5s3.9 1.1 4.5 3.5" />
      <path d="M14 18c.4-1.6 1.6-2.5 3-2.5 1.2 0 2.2.6 2.8 1.8" />
    </svg>
  );
}

export function IconHub(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 11.5 12 5l8 6.5V20H4v-8.5Z" />
      <path d="M10 20v-6h4v6" />
    </svg>
  );
}

export function IconTag(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3 12V4h8l10 10-8 8L3 12Z" />
      <circle cx="8" cy="8" r="1.25" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconLock(props) {
  return (
    <svg {...base} {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function IconNodes(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="7" cy="8" r="2.5" />
      <circle cx="17" cy="7" r="2.5" />
      <circle cx="12" cy="17" r="2.5" />
      <path d="M9 9.5 10.5 15M15.2 8.8 13.2 15" />
    </svg>
  );
}

export function IconCheck(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12.5 2.5 2.5L16 9.5" />
    </svg>
  );
}

export function IconArrow(props) {
  return (
    <svg {...base} {...props}>
      <path d="M5 12h12" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}
